// @mui
import { Container } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs';
// sections
import TaskNewEditForm from '../TaskNewEditForm';
import useResponsive from 'src/hooks/useResponsive';
import { useEffect } from 'react';
import { useAuthContext } from 'src/auth/hooks';
import { useLocales } from "src/locales";
import { routePrefix } from 'src/utils/methods/StandardMethods';
// ----------------------------------------------------------------------
type TabName = 'local' | 'share' | 'remote' | 'cloudStorage';
export interface BaseConfiguration {
    name: string;
}
export interface Files {
    local: File[];
    share: string[];
    remote: string[];
    cloudStorage: string[];
}
export interface CreateTaskData {
    projectId: number | null;
    basic: BaseConfiguration;
    subset: string;
    labels: any[];
    files: Files;
    activeFileManagerTab: TabName;
    cloudStorageId: number | null;
}

interface Props {
    onCreate: (data: CreateTaskData, onProgress?: (status: string) => void) => Promise<any>;
}

export default function TaskCreatePage() {
    const isDesktop = useResponsive('up', 'lg');
    const { translate } = useLocales();
    const { user, setDocumentTitle } = useAuthContext();
    useEffect(() => {
        setDocumentTitle(translate("New Task"))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    

    return (
        <>
            <Container maxWidth={false}>
                {isDesktop && <CustomBreadcrumbs
                    heading={translate("Create a new task")}
                    links={[
                        {
                            name: translate("Dashboard"),
                            href: PATH_DASHBOARD.dashboard.dash(routePrefix(user)),
                        },
                        {
                            name: translate("Task List"),
                            href: PATH_DASHBOARD.dataTraining.list(routePrefix(user)),
                        },
                        { name: translate("New Task") },
                    ]}
                />}
                <TaskNewEditForm isEdit={false} edit={true} />
            </Container>
        </>
    );
}
